/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  UserInfoHeader.tsx
*
* Project Title :  Checkout
*
* Description	:
*
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : Archana P(E542450)
*
* @Date			: Jul 29, 2019
*
* @Version      : Version 1.0

* By            : Archana P (E542450)
* On            : Sep 13 , 2019
* Description   : ASDS-1079: Updating code to navigate to Purchase Software page when SoldTo/ShipTo is selected
* By            : H224423
* On            : Oct 10, 2019
* Description   : ASDS-1478 - Grid level resposnive changes and UI issue fixes
 *  By            : h267743
 * On            : Oct 14, 2019
 * Description   : ASDS-1477 - Added onContinue function to toggle select Account
 *
 * By            : SandeepRaja
 * On            : Dec 03, 2019
 * Description   : ASDS-1951: Change Account-Delete APU MSA from Cart
 *
 * By            : H224423
 * On            : Feb 13, 2019
 * Description   : ASDS-2055 Change account delete MSA APU product.
 *
 * By            : H224423
 * On            : Feb 17, 2019
 * Description   : ASDS-2055 => ASDS-2346 issue fixes.
 *
 * By            : Deepthi Bachu(E844276)
 * On            : Mar 13, 2020
 * Description   : ASDS-2414 - APU MSA - acknowledge after deleting product from cart for address change
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Mar 19, 2020
 * Description   : ASDS-2443 - Added My Licenses, Asds Dashboard Links for Navigation from checkout
 *
 * By            : H224423
 * On            : 09 Apr, 2020
 * Description   : ASDS-2497 APU SIT Fixes. Added condition to display customer name
 *
 * By            : H422336
 * On            : Sep 7 2020
 * Description   : ASDS-2748 - UI Enhancements as part of Phase II
 *
 * By            : H422336
 * On            : Oct, 29 2020
 * Description   : ASDS-3793 UI Enhancements for Phase-II
 *
 * By            : H422337
 * On            : Nov 01, 2020
 * Description   : ASDS-3265 Enhancements of phase-2 - Purchase Order Quantity validation & Delete All MSA products
 *
 * By            : H422337
 * On            : Nov, 19 2020
 * Description   : ASDS-4083 UI Enhancements for Phase-II  bug fix & Delete All  products from the cart
 *
******************************************************************************/
import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Button, Grid, Icon } from '@scuf/common';
import { connect } from 'react-redux';
import SelectAccount from '../SelectAccount/selectAccount';
import CartPopup from '../Cart/CartPopup';
import { logInfo } from '../../../utils/console-utility';
import { getProperty } from 'utils/util';
import  { CheckoutServiceURL } from '../constants/checkout-constants';
import DeleteMSAProduct from '../SelectAccount/DeleteMSAProducts';
import DeleteDLMUWProduct from '../SelectAccount/DeleteDLMUWProduct';
import CartDetailsActions from '../redux/actions/cart-details-actions';
import RouteConstants from '../constants/route-constants';
import './UserInfoHeader.css';


// Added ShowCart Page - ASDS-689
interface UserInfoHeaderState {
}

class CustomerInfo extends React.Component<any, any> {
  state = {
    shouldDisplaySelectAccount: false,
    shouldDisplayDeleteCart: false,
    shouldDisplayDlmuwDeleteCart: false,
  };
  constructor(props: any) {
    super(props);
    this.toggleSelectAccount = this.toggleSelectAccount.bind(this);
    this.toggleDisplayDeleteCart = this.toggleDisplayDeleteCart.bind(this);
    this.onSelectAccountClick = this.onSelectAccountClick.bind(this);
    this.toggleDisplayDlmuwDeleteCart = this.toggleDisplayDlmuwDeleteCart.bind(this);
  }
  componentDidMount() {
    // getting selected cart list for apu msa product deletion when the billing address is changed
    const userId = this.props.userId;
    if (userId) {
      if (this.props.location.pathname !== RouteConstants.PURCHASE_SOFTWARE) {
        this.props.getSelectedCartList(userId, 'selectedcart');
      }
    }
  }
  onSelectAccountClick(){
    const selectedCartList = this.props.selectedCartList;
    let doesCartHaveProds: boolean = false;

    if (selectedCartList && selectedCartList.cartList.length !== 0) {
      doesCartHaveProds = true;
      // selectedCartList.cartList.forEach(prodInCart => {
      //   if (prodInCart.apuProductConfig && prodInCart.apuProductConfig.customerType && prodInCart.apuProductConfig.customerType === CheckoutConstants.CUSTOMER_CATEGORY_MSA) {
      //     doesCartHaveMSAProds = true;
      //   } else if (prodInCart.categoryName.toLowerCase() === CheckoutConstants.DLMUW_CATEGORY_NAME){
      //     doesCartHaveDlmuwProducts = true;
      //   }
      // });
    }

    if (doesCartHaveProds) {
      this.toggleDisplayDeleteCart();
    }
    else {
      this.toggleSelectAccount('');
    }
  }

  toggleDisplayDeleteCart() {
    this.setState({
        shouldDisplayDeleteCart: !this.state.shouldDisplayDeleteCart,
    });
  }

  toggleDisplayDlmuwDeleteCart() {
    this.setState({
      shouldDisplayDlmuwDeleteCart: !this.state.shouldDisplayDlmuwDeleteCart,
    });
  }

  toggleSelectAccount(loc: string) {
    this.setState(
      {
        shouldDisplayDeleteCart: false,
        shouldDisplayDlmuwDeleteCart: false,
        shouldDisplaySelectAccount: !this.state.shouldDisplaySelectAccount
      },
      () => this.redirectToSource(loc)
    );
  }

  redirectToSource(loc: string) {
    if (loc === 'close' && !this.props.customerInfo.customerName) {
      // if previouly selected any address, display checkout. Else redirect to ads
      window.location.href = getProperty(CheckoutServiceURL.ADS_DASHBOARD_URL);
    }
  }

  render() {
    return (
      <Grid.Column width={4} xlOrder={1} xsOrder={1} mWidth={4} xsWidth={8}>
        {this.state.shouldDisplayDeleteCart && (
          <DeleteMSAProduct
            open={true}
            onClose={this.toggleDisplayDeleteCart}
            onContinue={() => this.toggleSelectAccount('')}
          />
        )}

        {this.state.shouldDisplayDlmuwDeleteCart && (
          <DeleteDLMUWProduct
            open={true}
            onClose={this.toggleDisplayDlmuwDeleteCart}
            onContinue={() => this.toggleSelectAccount('')}
          />
        )}

        {/* {this.props.deleteAllProductsSuccessFlag &&
                    <Modal
                        size="small"
                        open={this.props.deleteAllProductsSuccessFlag}
                        closeOnDimmerClick={false}
                        closeOnDocumentClick={false}
                    >
                    <Modal.Content>
                        <p>All APU product(s) configured and added to the cart with MSA contract numbers are successfully deleted.</p>
                    </Modal.Content>
                    <Modal.Footer>
                        <div className="display-flex">
                        <div>
                                <Button type="primary" size="medium" content="OK"
                                        onClick={() => {this.props.updatedeleteAllProductsSuccessFlag(!this.props.deleteAllProductsSuccessFlag)}}/>
                            </div>
                        </div>
                    </Modal.Footer>
                    </Modal>

                    } */}


        {this.state.shouldDisplaySelectAccount && (
          <SelectAccount
            open={true}
            onClose={() => this.toggleSelectAccount('close')}
            onContinue={() => this.toggleSelectAccount('')}
          />
        )}
        {this.props.customerInfo.customerName &&
          <div
            className={`cust-drop-down-font customer-name`}
            onClick={() => this.onSelectAccountClick()}
          >
            {this.props.customerInfo.customerName}
          &nbsp;
          <Icon name="caret-down" size="medium" />
          </div>
        }
      </Grid.Column>
    );
  }
}

function mapStateToProps(state) {
    logInfo(state);
    const { payload } = state.selectAccount.selectAccountDetails;
    const customerName = payload.customerName || '';
    const selectedCartList = state.cartDetails.selectedCartList;
    const userId = state.userValidationData.payload.userInfo.customer_sub;
    let deleteAllProductsSuccessFlag = state.cartDetails.deleteAllProductsSuccessFlag;


    return {
        customerInfo: { customerName },
        selectedCartList: selectedCartList,
        userId: userId,
        deleteAllProductsSuccessFlag : deleteAllProductsSuccessFlag,


    };
}

const mapDispatchToProps = {
  getSelectedCartList: CartDetailsActions.getCartData,
  updatedeleteAllProductsSuccessFlag: CartDetailsActions.updatedeleteAllProductsSuccessFlag
};

const CustomerInfoComponent = connect(mapStateToProps, mapDispatchToProps)(withRouter(CustomerInfo));

/**
 * @author ASDS Team
 * @description Displays Cart Icom, Customer account and purchased softwares.
 */
class UserInfoHeader extends React.PureComponent<RouteComponentProps, UserInfoHeaderState> {

    constructor(props: RouteComponentProps) {
        super(props);
        this.onClickHandle = this.onClickHandle.bind(this);
    }

  handleOrderHistory() {
    this.props.history.push(RouteConstants.ORDER_HISTORY);
  }

  handleProductListing() {
    this.props.history.push(RouteConstants.PURCHASE_SOFTWARE);
  }

  private onClickHandle(input: string) {
    switch (input) {
      case 'Dashboard' :
            window.open(
              getProperty(CheckoutServiceURL.ADS_DASHBOARD_URL),
              '_blank' // <- This is what makes it open in a new window.
              );
            break;
      case 'Licenses' :
            window.open(
              getProperty(CheckoutServiceURL.MY_LICENSES_URL),
              '_blank' // <- This is what makes it open in a new window.
            );
            break;
      case 'UserGuide':
        window.open(
          getProperty(CheckoutServiceURL.USER_GUIDE_URL),
          '_blank' // <- This is what makes it open in a new window.
        );
        break;
      case 'Needhelp':
        window.open(
          getProperty(CheckoutServiceURL.NEED_HELP_URL),
          '_blank' // <- This is what makes it open in a new window.
        );
        break;
      default:
        break;
      }
    }

    render() {
        return (
            <Grid.Row>
                <Grid.Column className="fullwidthRow user-info-header">
                    <div className="secondaryNav">
                      <Grid>
                          <Grid.Row>
                              <CustomerInfoComponent />
                              <Grid.Column width={5} mWidth={8} xsWidth={12} xlOrder={2} xsOrder={2}>
                                <div className="secondnav">
                                    <Button className = "secondnavLink" type="link" content="Dashboard" onClick={() => this.onClickHandle('Dashboard')} />
                                    <Button className = {this.props.location.pathname === RouteConstants.PURCHASE_SOFTWARE ? 'secondnavLink active' : 'secondnavLink'} type="link" content="Product Listing" onClick={() => this.handleProductListing()} />
                                    <Button className = "secondnavLink" type="link" content="My Licenses" onClick={() => this.onClickHandle('Licenses')} />
                                    <Button className = {this.props.location.pathname === RouteConstants.ORDER_HISTORY ? 'secondnavLink active' : 'secondnavLink'} type="link" content="Order History" onClick={() => this.handleOrderHistory()} />
                                </div>
                              </Grid.Column>
                              <Grid.Column width={3} mWidth={6} xsWidth={12} xlOrder={3} xsOrder={2}>
                                <div className="secondnav1">
                                  <Button className = "secondnavLink1" type="link" content="User Guide" onClick={() => this.onClickHandle('UserGuide')}/>
                                  <Button className = "secondnavLink1" type="link" content="Need Help?" onClick={() => this.onClickHandle('Needhelp')}/>
                                  <span className="cart-popup-icon-left-space"><CartPopup /> </span>
                                </div>
                              </Grid.Column>
                          </Grid.Row>
                          </Grid>
                    </div>
                </Grid.Column>
            </Grid.Row>
        );
    }
}

export default withRouter(UserInfoHeader);